import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const documentsDetails = createAsyncThunk('documentsDetails', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `resource/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const documentsDetailsSlice = createSlice({
    name: 'documentsDetails',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(documentsDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = '';
            }

        });
        builder.addCase(documentsDetails.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default documentsDetailsSlice.reducer;
